import Referrals from 'components/pages/Referrals/Referrals';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('referrals', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(Referrals, {
  noMarginBottomMobile: true,
  requiresAuthentication: true,
  metaData: {
    title: 'Refer a Friend',
    description: 'Refer a friend and earn rewards for successful referrals.',
  },
});
